var React = require('react');

function IconQuote (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.3333 35.3333H17.3333L22 26V12H8V26H15L10.3333 35.3333ZM29 35.3333H36L40.6667 26V12H26.6667V26H33.6667L29 35.3333Z","fill":"black","stroke":"black","strokeWidth":"1.5"}));
}

IconQuote.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = IconQuote;

IconQuote.default = IconQuote;
